import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Overview",
    body: [
      "Network in Colors (\"we,\" \"us,\" or \"our\") respects your privacy. This Privacy Policy explains what information we collect through our website (the \"Site\"), how we use it, and the choices you have.",
    ],
  },
  {
    heading: "Information We Collect",
    body: [
      "When you submit our consultation form, we collect the information you provide: your name, company name, email address, phone number, approximate number of employees, the services you are interested in, and the contents of your message.",
      "We do not collect payment information through the Site, and we do not use advertising trackers or analytics cookies that identify you personally.",
    ],
  },
  {
    heading: "How We Use Your Information",
    body: [
      "We use the information you submit to respond to your enquiry, schedule and prepare for a consultation, and communicate with you about our services. With your consent, we may also follow up about relevant services after an initial conversation.",
      "We do not sell, rent, or trade your personal information to third parties for their marketing purposes.",
    ],
  },
  {
    heading: "How Your Information Is Stored and Shared",
    body: [
      "Enquiry details are stored securely in our website database and delivered to our team by email. We use Resend, a third-party email delivery provider, to send enquiry notifications; your submitted information is processed by Resend solely for that delivery.",
      "We may disclose information if required by law, regulation, or valid legal process, or to protect the rights, property, or safety of Network in Colors, our clients, or others.",
    ],
  },
  {
    heading: "Data Retention",
    body: [
      "We retain enquiry information for as long as needed to respond to you, manage our relationship with you, and meet reasonable record-keeping needs. You may ask us to delete your information at any time using the contact details below.",
    ],
  },
  {
    heading: "Cookies",
    body: [
      "The Site does not set advertising or cross-site tracking cookies. Any cookies or local storage used are limited to what is technically necessary for the Site to function.",
    ],
  },
  {
    heading: "Data Security",
    body: [
      "We use reasonable administrative and technical measures to protect the information submitted through the Site. No method of transmission or storage is completely secure, however, so we cannot guarantee absolute security.",
    ],
  },
  {
    heading: "Your Rights and Choices",
    body: [
      "You may request access to, correction of, or deletion of the personal information you have submitted to us. To make a request, email michelle@networkincolors.com and we will respond within a reasonable timeframe.",
    ],
  },
  {
    heading: "Children's Privacy",
    body: [
      "The Site is intended for business audiences and is not directed at children under 13. We do not knowingly collect personal information from children.",
    ],
  },
  {
    heading: "Changes to This Policy",
    body: [
      "We may update this Privacy Policy from time to time. Changes take effect when posted on this page, and the \"Last updated\" date above will be revised accordingly.",
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "Questions about this Privacy Policy or your information? Email us at michelle@networkincolors.com.",
    ],
  },
];

const Privacy = () => (
  <LegalPage
    title="Privacy Policy"
    updated="August 2026"
    sections={SECTIONS}
    testId="privacy-page"
  />
);

export default Privacy;
